import { render, staticRenderFns } from "./oauth.vue?vue&type=template&id=f4e1bb38&scoped=true&"
import script from "./oauth.vue?vue&type=script&lang=js&"
export * from "./oauth.vue?vue&type=script&lang=js&"
import style0 from "./oauth.vue?vue&type=style&index=0&id=f4e1bb38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e1bb38",
  null
  
)

export default component.exports